import { BooleanSchema } from 'yup';

import { TypeBase } from './TypeBase';

export abstract class BooleanTypeBase extends TypeBase<BooleanSchema<any>> {}
